import { render, staticRenderFns } from "./MobileGameDetail.vue?vue&type=template&id=071e6b5a&"
import script from "./MobileGameDetail.vue?vue&type=script&lang=js&"
export * from "./MobileGameDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports